import { useState } from 'react';
import { IoTrashOutline } from 'react-icons/io5';
import Pagination from '../Pagination';
import { tableBackgroundColor } from '../utils/tableBackgroundColor';
import DrawerModel from '../utils/drawer';
import { CreateNewsLetter } from './CreateNewsLetter';
import { DrawerNewsLetter, INewsLetter } from '@/interfaces/entities/newsLetter';
import { useGetAllNewsLetters } from '@/hooks/newsLetter/useGetAllNewsLetter';
import Error from '../Error';
import Loader from '../Loader';
import { NewsLetterError } from '@/exceptions/news_letter/news.enum';
import useDeleteNewsLetter from '@/hooks/newsLetter/useDeleteNewsLetter';
import { notificationService } from '@/services/notification.service';
import FilePreviewModal from '../utils/FilePreviewModal';



export const NewsLetterTable = () => {
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isNews, setIsNews] = useState<INewsLetter | null>();
    const [currentPage, setCurrentPage] = useState(1);
    const [modalVisible, setModalVisible] = useState(false);
    const [url, setUrl] = useState('');
    const { newsLetters, isLoading, isError, error, totalPages, isPending } =
        useGetAllNewsLetters(currentPage);
    const deleteNews = useDeleteNewsLetter()
    if (isLoading || isPending) {
        return <Loader />;
    }

    if (isError) {
        return (
            <Error message={error ? error.message : NewsLetterError.NEWS_ERROR} />

        );
    }

    const openEditModal = (blogger: INewsLetter) => {
        setIsNews(blogger);
        setIsCreateModalOpen(true);
    };


    const openCreateModal = () => {
        setIsCreateModalOpen(true);
    };


    const handleDelete = async (id: number) => {
        try {
            await deleteNews.mutate(id);
        } catch (error) {
            notificationService.error("NewsLetter deleted failed");
        }
    };

    const handleToggle = () => {
        setIsCreateModalOpen(false);
        setIsNews(null)
    }


    const handlePreview = (url: string | null) => {
        if (url) {
            setUrl(url)
            setModalVisible(true)
        };
    };

    return (
        <>
            <div className="px-4 sm:px-6 lg:px-8 w-full mb-10">
                <div className="sm:flex sm:items-center">
                    <div className="flex justify-between font-bold sm:flex-auto">
                        <h1
                            data-test="h1-categories"
                            className="text-base font-semibold leading-6 text-gray-900"
                        >
                            NewsLetter
                        </h1>
                        <button
                            className="text-indigo-600 hover:text-indigo-900"
                            data-test="button-add-category"
                            onClick={openCreateModal}
                        >
                            Add NewsLetter
                        </button>
                    </div>
                </div>

                {newsLetters.length ? <div className="mt-8 w-full  flow-root">
					<div className=" w-full overflow-x-auto">
						<div className="inline-block  min-w-[1100px] w-full py-2 align-middle">
                            <table className="min-w-full table-auto divide-y divide-gray-300 border-red-300  border-spacing-x-4">
                                <thead>
                                    <tr className='gap-x-2'>
                                        <th
                                            scope="col"
                                            className="w-1/12  py-3.5 text-center text-sm font-semibold text-gray-900 "
                                            data-test="th-id"
                                        >
                                            ID
                                        </th>
                                        <th
                                            scope="col"
                                            className="w-2/12 py-3.5 text-center text-sm font-semibold text-gray-900"
                                            data-test="th-name"
                                        >
                                            Title
                                        </th>
                                        <th
                                            scope="col"
                                            className="w-2/12 py-3.5 text-center text-sm font-semibold text-gray-900"
                                            data-test="th-heading"
                                        >
                                            Heading
                                        </th>
                                        <th
                                            scope="col"
                                            className="w-2/12 py-3.5 text-center text-sm font-semibold text-gray-900"
                                            data-test="th-description1"
                                        >
                                            Description1
                                        </th>
                                        <th
                                            scope="col"
                                            className="w-2/12 py-3.5 text-center text-sm font-semibold text-gray-900"
                                            data-test="th-location"
                                        >
                                            Location
                                        </th>
                                        <th
                                            scope="col"
                                            className="w-1/12 py-3.5 text-center text-sm font-semibold text-gray-900"
                                            data-test="th-img"
                                        >
                                            Image
                                        </th>
                                        <th
                                            scope="col"
                                            className="w-1/12 py-3.5 text-center text-sm font-semibold text-gray-900"
                                            data-test="th-pdf"
                                        >
                                            Pdf
                                        </th>


                                        <th
                                            scope="col"
                                            className="w-1/12  py-3.5 text-center text-sm font-semibold text-gray-900"
                                            data-test="th-actions"
                                        >
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {newsLetters.map((news: INewsLetter, index) => {
                                        return (
                                            <tr
                                                key={news.id}
                                                className={`${tableBackgroundColor(
                                                    index,
                                                )} hover:bg-gray-200 min-h-8 gap-x-2`}
                                            >
                                                <td
                                                    data-test="td-id"
                                                    className="text-center max-w-sm py-4  text-sm font-medium text-gray-900 "
                                                >
                                                    {news.id}
                                                </td>
                                                <td
                                                    data-test="td-name"
                                                    className="text-center max-w-md py-4 text-sm text-gray-500"
                                                >
                                                    {news.title}
                                                </td>
                                                <td
                                                    data-test="td-description"
                                                    className="text-center max-w-md py-4 text-sm text-gray-500"
                                                >
                                                    {news.heading}
                                                </td>
                                                <td
                                                    data-test="td-description1"
                                                    className="text-center max-w-md py-4 text-sm text-gray-500"
                                                >
                                                    {news.description1}
                                                </td>
                                                <td
                                                    data-test="td-location"
                                                    className="text-center max-w-md py-4 text-sm text-gray-500"
                                                >
                                                    {news.location}
                                                </td>
                                                <td
                                                    data-test="td-image"
                                                    className="text-center max-w-md py-4 text-sm text-gray-500"
                                                >
                                                    <button
                                                        data-test="image-button"
                                                        className="text-indigo-600 hover:text-indigo-900 text-[16px] font-semibold"
                                                        onClick={() => handlePreview(news.img)}
                                                    >
                                                        View
                                                    </button>
                                                </td>
                                                <td
                                                    data-test="td-pdf"
                                                    className="text-center max-w-md py-4 text-sm text-gray-500"
                                                >
                                                    <button
                                                        data-test="pdf-button"
                                                        className="text-indigo-600 hover:text-indigo-900 text-[16px] font-semibold"
                                                        onClick={() => handlePreview(news.pdf)}
                                                    >
                                                        View
                                                    </button>
                                                </td>

                                                <td
                                                    data-test="edit-notification-button"
                                                    className="text-center text-md font-semibold "
                                                >
                                                    <div className="flex justify-center items-center gap-6">
                                                        <button
                                                            data-test="edit-news-button"
                                                            className="text-indigo-600 hover:text-indigo-900"
                                                            onClick={() => openEditModal(news)}
                                                        >
                                                            Edit
                                                            <span className="sr-only">{news.id}</span>
                                                        </button>

                                                        <IoTrashOutline
                                                            className="cursor-pointer"
                                                            onClick={() => handleDelete(news.id)}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Pagination
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalPages={totalPages as number}
                    />
                </div> : <div className="w-full"><h1
                    data-test="h1-news"
                    className="text-base font-semibold leading-6 text-gray-900"
                >
                    No NewsLetters Available
                </h1></div>}
                <FilePreviewModal
                    visible={modalVisible}
                    url={url}
                    onClose={() => setModalVisible(false)}
                />

            </div>
            <DrawerModel isOpen={isCreateModalOpen} isTitle={isNews ? DrawerNewsLetter.Edit : DrawerNewsLetter.Create} setToggle={handleToggle}>
                <CreateNewsLetter editNews={isNews ?? null} setToggle={handleToggle} />
            </DrawerModel>
        </>
    );
};


